/* eslint-disable  */
import React from 'react';
import { Table } from 'semantic-ui-react';
import { renderPrice, Cell, Title } from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    },
    green: {
        backgroundColor: '#CCFFCC'
    },
    yellow: {
        backgroundColor: 'yellow',
        padding: 0
    }
};


const Reflections = props => {

    const { data, isLoading, matrixType } = props;

    const {
        ref,
        Trigger
    } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>
            <Title data={Object.values(data)} title='Reflections'/>
            <PrintDate isForPDF={false}/>
            <Table singleLine textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' textAlign='center' content='North View'/>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row textAlign='center'>
                        <Table.Cell colSpan='10'/>
                        <Table.Cell colSpan='2' content='2/2-B'/>
                        <Table.Cell colSpan='2'/>
                        <Table.Cell colSpan='2' content='2/2-Deluxe'/>
                        <Table.Cell colSpan='2'/>
                        <Table.Cell colSpan='2' content='2/2-B'/>
                        <Table.Cell colSpan='2'/>
                        <Table.Cell colSpan='2' content='2/2-B'/>
                        <Table.Cell colSpan='12'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='10'/>
                        <Cell unit={'1202'} price={renderPrice(data?.['1-1202'], matrixType)} status={data?.['1-1202']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1201'} price={renderPrice(data?.['1-1201'], matrixType)} status={data?.['1-1201']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1210'} price={renderPrice(data?.['1-1210'], matrixType)} status={data?.['1-1210']?.status}/>
                        <Table.Cell colSpan='2'/>
                        {/* <Cell unit={'1211'} price={renderPrice(data?.['1-1211'], matrixType)} status={data?.['1-1211']?.status}/> */}
                        <Table.Cell colSpan='12'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='10'/>
                        <Cell unit={'1102'} price={renderPrice(data?.['1-1102'], matrixType)} status={data?.['1-1102']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1101'} price={renderPrice(data?.['1-1101'], matrixType)} status={data?.['1-1101']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1110'} price={renderPrice(data?.['1-1110'], matrixType)} status={data?.['1-1110']?.status}/>
                        <Table.Cell colSpan='2'/>
                        {/* <Cell unit={'1111'} price={renderPrice(data?.['1-1111'], matrixType)} status={data?.['1-1111']?.status}/> */}
                        <Table.Cell colSpan='12'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='10'/>
                        <Cell unit={'1002'} price={renderPrice(data?.['1-1002'], matrixType)} status={data?.['1-1002']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1001'} price={renderPrice(data?.['1-1001'], matrixType)} status={data?.['1-1001']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'1010'} price={renderPrice(data?.['1-1010'], matrixType)} status={data?.['1-1010']?.status}/>
                        <Table.Cell colSpan='2'/>
                        {/* <Cell unit={'1011'} price={renderPrice(data?.['1-1011'], matrixType)} status={data?.['1-1011']?.status}/> */}
                        <Table.Cell colSpan='12'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='2' />
                        <Cell unit={'902'} price={renderPrice(data?.['1-0902'], matrixType)} status={data?.['1-0902']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'901'} price={renderPrice(data?.['1-0901'], matrixType)} status={data?.['1-0901']?.status}/>
                        <Table.Cell colSpan='2'/>
                        <Cell unit={'910'} price={renderPrice(data?.['1-0910'], matrixType)} status={data?.['1-0910']?.status}/>
                        <Table.Cell colSpan='2'/>
                        {/* <Cell unit={'911'} price={renderPrice(data?.['1-0911'], matrixType)} status={data?.['1-0911']?.status}/> */}
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='4' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='2' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'804'} price={renderPrice(data?.['1-0804'], matrixType)} status={data?.['1-0804']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'803'} price={renderPrice(data?.['1-0803'], matrixType)} status={data?.['1-0803']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'802'} price={renderPrice(data?.['1-0802'], matrixType)} status={data?.['1-0802']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'801'} price={renderPrice(data?.['1-0801'], matrixType)} status={data?.['1-0801']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'810'} price={renderPrice(data?.['1-0810'], matrixType)} status={data?.['1-0810']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'811'} price={renderPrice(data?.['1-0811'], matrixType)} status={data?.['1-0811']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'812'} price={renderPrice(data?.['1-0812'], matrixType)} status={data?.['1-0812']?.status}/>
                        <Table.Cell colSpan='4' />
                        <Cell unit={'814'} price={renderPrice(data?.['1-0814'], matrixType)} status={data?.['1-0814']?.status}/>
                        <Table.Cell colSpan='2' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'704'} price={renderPrice(data?.['1-0704'], matrixType)} status={data?.['1-0704']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'703'} price={renderPrice(data?.['1-0703'], matrixType)} status={data?.['1-0703']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'702'} price={renderPrice(data?.['1-0702'], matrixType)} status={data?.['1-0702']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'701'} price={renderPrice(data?.['1-0701'], matrixType)} status={data?.['1-0701']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'710'} price={renderPrice(data?.['1-0710'], matrixType)} status={data?.['1-0710']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'711'} price={renderPrice(data?.['1-0711'], matrixType)} status={data?.['1-0711']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'712'} price={renderPrice(data?.['1-0712'], matrixType)} status={data?.['1-0712']?.status}/>
                        <Table.Cell colSpan='4' />
                        <Cell unit={'714'} price={renderPrice(data?.['1-0714'], matrixType)} status={data?.['1-0714']?.status}/>
                        <Table.Cell colSpan='2' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'604'} price={renderPrice(data?.['1-0604'], matrixType)} status={data?.['1-0604']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'603'} price={renderPrice(data?.['1-0603'], matrixType)} status={data?.['1-0603']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'602'} price={renderPrice(data?.['1-0602'], matrixType)} status={data?.['1-0602']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'601'} price={renderPrice(data?.['1-0601'], matrixType)} status={data?.['1-0601']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'610'} price={renderPrice(data?.['1-0610'], matrixType)} status={data?.['1-0610']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'611'} price={renderPrice(data?.['1-0611'], matrixType)} status={data?.['1-0611']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'612'} price={renderPrice(data?.['1-0612'], matrixType)} status={data?.['1-0612']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A'/>
                        <Cell unit={'614'} price={renderPrice(data?.['1-0614'], matrixType)} status={data?.['1-0614']?.status}/>
                        <Table.Cell colSpan='2' content='3/2-U'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' content='2/2-Z'/>
                        <Cell unit={'504'} price={renderPrice(data?.['1-0504'], matrixType)} status={data?.['1-0504']?.status}/>
                        <Table.Cell colSpan='2' content='1/1-AX'/>
                        <Cell unit={'503'} price={renderPrice(data?.['1-0503'], matrixType)} status={data?.['1-0503']?.status}/>
                        <Table.Cell colSpan='2' content='2/2-B'/>
                        <Cell unit={'502'} price={renderPrice(data?.['1-0502'], matrixType)} status={data?.['1-0502']?.status}/>
                        <Table.Cell colSpan='2' content='3/2-N'/>
                        <Cell unit={'501'} price={renderPrice(data?.['1-0501'], matrixType)} status={data?.['1-0501']?.status}/>
                        <Table.Cell colSpan='2' content='3/2-N'/>
                        <Cell unit={'510'} price={renderPrice(data?.['1-0510'], matrixType)} status={data?.['1-0510']?.status}/>
                        <Table.Cell colSpan='2' content='2/2-B'/>
                        <Cell unit={'511'} price={renderPrice(data?.['1-0511'], matrixType)} status={data?.['1-0511']?.status}/>
                        <Table.Cell colSpan='2' content='1/1-AX'/>
                        <Cell unit={'512'} price={renderPrice(data?.['1-0512'], matrixType)} status={data?.['1-0512']?.status}/>
                        <Table.Cell colSpan='2' content='1/1-AX'/>
                        <Cell unit={'514'} price={renderPrice(data?.['1-0514'], matrixType)} status={data?.['1-0514']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'516'} price={renderPrice(data?.['1-0516'], matrixType)} status={data?.['1-0516']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'404'} price={renderPrice(data?.['1-0404'], matrixType)} status={data?.['1-0404']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'403'} price={renderPrice(data?.['1-0403'], matrixType)} status={data?.['1-0403']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'402'} price={renderPrice(data?.['1-0402'], matrixType)} status={data?.['1-0402']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'401'} price={renderPrice(data?.['1-0401'], matrixType)} status={data?.['1-0401']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'410'} price={renderPrice(data?.['1-0410'], matrixType)} status={data?.['1-0410']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'411'} price={renderPrice(data?.['1-0411'], matrixType)} status={data?.['1-0411']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'412'} price={renderPrice(data?.['1-0412'], matrixType)} status={data?.['1-0412']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'414'} price={renderPrice(data?.['1-0414'], matrixType)} status={data?.['1-0414']?.status}/>
                        <Table.Cell colSpan='6' />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'304'} price={renderPrice(data?.['1-0304'], matrixType)} status={data?.['1-0304']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'303'} price={renderPrice(data?.['1-0303'], matrixType)} status={data?.['1-0303']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'302'} price={renderPrice(data?.['1-0302'], matrixType)} status={data?.['1-0302']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'301'} price={renderPrice(data?.['1-0301'], matrixType)} status={data?.['1-0301']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'310'} price={renderPrice(data?.['1-0310'], matrixType)} status={data?.['1-0310']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'311'} price={renderPrice(data?.['1-0311'], matrixType)} status={data?.['1-0311']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'312'} price={renderPrice(data?.['1-0312'], matrixType)} status={data?.['1-0312']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'314'} price={renderPrice(data?.['1-0314'], matrixType)} status={data?.['1-0314']?.status}/>
                        <Table.Cell colSpan='6' />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'204'} price={renderPrice(data?.['1-0204'], matrixType)} status={data?.['1-0204']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'203'} price={renderPrice(data?.['1-0203'], matrixType)} status={data?.['1-0203']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'202'} price={renderPrice(data?.['1-0202'], matrixType)} status={data?.['1-0202']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'201'} price={renderPrice(data?.['1-0201'], matrixType)} status={data?.['1-0201']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'210'} price={renderPrice(data?.['1-0210'], matrixType)} status={data?.['1-0210']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'211'} price={renderPrice(data?.['1-0211'], matrixType)} status={data?.['1-0211']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'212'} price={renderPrice(data?.['1-0212'], matrixType)} status={data?.['1-0212']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'214'} price={renderPrice(data?.['1-0214'], matrixType)} status={data?.['1-0214']?.status}/>
                        <Table.Cell colSpan='6' />
                    </Table.Row>
                </Table.Body>
            </Table>

            <Table singleLine textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' textAlign='center' content='South View'/>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row textAlign='center'>
                        <Table.Cell colSpan='6'/>
                        <Table.Cell colSpan='2' content='2/2-L'/>
                        <Table.Cell colSpan='2' content='1/1-A'/>
                        <Table.Cell colSpan='2' content='1/1-A'/>
                        <Table.Cell colSpan='2' content='1/1-A'/>
                        <Table.Cell colSpan='2' content='2/2-L'/>
                        <Table.Cell colSpan='6'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='6'/>
                        <Cell unit={'1207'} price={renderPrice(data?.['1-1207'], matrixType)} status={data?.['1-1207']?.status}/>
                        <Cell unit={'1208'} price={renderPrice(data?.['1-1208'], matrixType)} status={data?.['1-1208']?.status}/>
                        <Cell unit={'1209'} price={renderPrice(data?.['1-1209'], matrixType)} status={data?.['1-1209']?.status}/>
                        <Cell unit={'1221'} price={renderPrice(data?.['1-1221'], matrixType)} status={data?.['1-1221']?.status}/>
                        <Cell unit={'1220'} price={renderPrice(data?.['1-1220'], matrixType)} status={data?.['1-1220']?.status}/>
                        <Table.Cell colSpan='6'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='6'/>
                        <Cell unit={'1107'} price={renderPrice(data?.['1-1107'], matrixType)} status={data?.['1-1107']?.status}/>
                        <Cell unit={'1108'} price={renderPrice(data?.['1-1108'], matrixType)} status={data?.['1-1108']?.status}/>
                        <Cell unit={'1109'} price={renderPrice(data?.['1-1109'], matrixType)} status={data?.['1-1109']?.status}/>
                        <Cell unit={'1121'} price={renderPrice(data?.['1-1121'], matrixType)} status={data?.['1-1121']?.status}/>
                        <Cell unit={'1120'} price={renderPrice(data?.['1-1120'], matrixType)} status={data?.['1-1120']?.status}/>
                        <Table.Cell colSpan='6'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='6'/>
                        <Cell unit={'1007'} price={renderPrice(data?.['1-1007'], matrixType)} status={data?.['1-1007']?.status}/>
                        <Cell unit={'1008'} price={renderPrice(data?.['1-1008'], matrixType)} status={data?.['1-1008']?.status}/>
                        <Cell unit={'1009'} price={renderPrice(data?.['1-1009'], matrixType)} status={data?.['1-1009']?.status}/>
                        <Cell unit={'1021'} price={renderPrice(data?.['1-1021'], matrixType)} status={data?.['1-1021']?.status}/>
                        <Cell unit={'1020'} price={renderPrice(data?.['1-1020'], matrixType)} status={data?.['1-1020']?.status}/>
                        <Table.Cell colSpan='6'/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Cell unit={'907'} price={renderPrice(data?.['1-0907'], matrixType)} status={data?.['1-0907']?.status}/>
                        <Cell unit={'908'} price={renderPrice(data?.['1-0908'], matrixType)} status={data?.['1-0908']?.status}/>
                        <Cell unit={'909'} price={renderPrice(data?.['1-0909'], matrixType)} status={data?.['1-0909']?.status}/>
                        <Cell unit={'921'} price={renderPrice(data?.['1-0921'], matrixType)} status={data?.['1-0921']?.status}/>
                        <Cell unit={'920'} price={renderPrice(data?.['1-0920'], matrixType)} status={data?.['1-0920']?.status}/>
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Table.Cell colSpan='2' />
                        <Table.Cell colSpan='2' content='1/1-A' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'805'} price={renderPrice(data?.['1-0805'], matrixType)} status={data?.['1-0805']?.status}/>
                        <Cell unit={'806'} price={renderPrice(data?.['1-0806'], matrixType)} status={data?.['1-0806']?.status}/>
                        <Cell unit={'807'} price={renderPrice(data?.['1-0807'], matrixType)} status={data?.['1-0807']?.status}/>
                        <Cell unit={'808'} price={renderPrice(data?.['1-0808'], matrixType)} status={data?.['1-0808']?.status}/>
                        <Cell unit={'809'} price={renderPrice(data?.['1-0809'], matrixType)} status={data?.['1-0809']?.status}/>
                        <Cell unit={'821'} price={renderPrice(data?.['1-0821'], matrixType)} status={data?.['1-0821']?.status}/>
                        <Cell unit={'820'} price={renderPrice(data?.['1-0820'], matrixType)} status={data?.['1-0820']?.status}/>
                        <Cell unit={'819'} price={renderPrice(data?.['1-0819'], matrixType)} status={data?.['1-0819']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'818'} price={renderPrice(data?.['1-0818'], matrixType)} status={data?.['1-0818']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'705'} price={renderPrice(data?.['1-0705'], matrixType)} status={data?.['1-0705']?.status}/>
                        <Cell unit={'706'} price={renderPrice(data?.['1-0706'], matrixType)} status={data?.['1-0706']?.status}/>
                        <Cell unit={'707'} price={renderPrice(data?.['1-0707'], matrixType)} status={data?.['1-0707']?.status}/>
                        <Cell unit={'708'} price={renderPrice(data?.['1-0708'], matrixType)} status={data?.['1-0708']?.status}/>
                        <Cell unit={'709'} price={renderPrice(data?.['1-0709'], matrixType)} status={data?.['1-0709']?.status}/>
                        <Cell unit={'721'} price={renderPrice(data?.['1-0721'], matrixType)} status={data?.['1-0721']?.status}/>
                        <Cell unit={'720'} price={renderPrice(data?.['1-0720'], matrixType)} status={data?.['1-0720']?.status}/>
                        <Cell unit={'719'} price={renderPrice(data?.['1-0719'], matrixType)} status={data?.['1-0719']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'718'} price={renderPrice(data?.['1-0718'], matrixType)} status={data?.['1-0718']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'605'} price={renderPrice(data?.['1-0605'], matrixType)} status={data?.['1-0605']?.status}/>
                        <Cell unit={'606'} price={renderPrice(data?.['1-0606'], matrixType)} status={data?.['1-0606']?.status}/>
                        <Cell unit={'607'} price={renderPrice(data?.['1-0607'], matrixType)} status={data?.['1-0607']?.status}/>
                        <Cell unit={'608'} price={renderPrice(data?.['1-0608'], matrixType)} status={data?.['1-0608']?.status}/>
                        <Cell unit={'609'} price={renderPrice(data?.['1-0609'], matrixType)} status={data?.['1-0609']?.status}/>
                        <Cell unit={'621'} price={renderPrice(data?.['1-0621'], matrixType)} status={data?.['1-0621']?.status}/>
                        <Cell unit={'620'} price={renderPrice(data?.['1-0620'], matrixType)} status={data?.['1-0620']?.status}/>
                        <Cell unit={'619'} price={renderPrice(data?.['1-0619'], matrixType)} status={data?.['1-0619']?.status}/>
                        <Table.Cell colSpan='2' content='1/1-A' />
                        <Cell unit={'618'} price={renderPrice(data?.['1-0618'], matrixType)} status={data?.['1-0618']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' content='2/2-Y'/>
                        <Cell unit={'505'} price={renderPrice(data?.['1-0505'], matrixType)} status={data?.['1-0505']?.status}/>
                        <Table.Cell colSpan='2' />
                        <Cell unit={'507'} price={renderPrice(data?.['1-0507'], matrixType)} status={data?.['1-0507']?.status}/>
                        <Cell unit={'508'} price={renderPrice(data?.['1-0508'], matrixType)} status={data?.['1-0508']?.status}/>
                        <Cell unit={'509'} price={renderPrice(data?.['1-0509'], matrixType)} status={data?.['1-0509']?.status}/>
                        <Cell unit={'521'} price={renderPrice(data?.['1-0521'], matrixType)} status={data?.['1-0521']?.status}/>
                        <Cell unit={'520'} price={renderPrice(data?.['1-0520'], matrixType)} status={data?.['1-0520']?.status}/>
                        <Cell unit={'519'} price={renderPrice(data?.['1-0519'], matrixType)} status={data?.['1-0519']?.status}/>
                        <Cell unit={'518'} price={renderPrice(data?.['1-0518'], matrixType)} status={data?.['1-0518']?.status}/>
                        <Table.Cell colSpan='2' />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'405'} price={renderPrice(data?.['1-0405'], matrixType)} status={data?.['1-0405']?.status}/>
                        <Table.Cell colSpan='20' />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'305'} price={renderPrice(data?.['1-0305'], matrixType)} status={data?.['1-0305']?.status}/>
                        <Table.Cell colSpan='20' />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'205'} price={renderPrice(data?.['1-0205'], matrixType)} status={data?.['1-0205']?.status}/>
                        <Table.Cell colSpan='20' />
                    </Table.Row>
                </Table.Body>
            </Table>

            <Table singleLine textAlign='center'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan='100' textAlign='center' content='East View'/>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row textAlign='center'>
                        <Table.Cell colSpan='4'/>
                        <Table.Cell colSpan='2' content='2/2-B (1,118 SQFT)' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell colSpan='2' content='1/1-AS (859 SQFT)' />
                        <Table.Cell colSpan='2' content='2/2-B (1,118 SQFT)' />
                        <Cell unit={'517'} price={renderPrice(data?.['1-0517'], matrixType)} status={data?.['1-0517']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'515'} price={renderPrice(data?.['1-0515'], matrixType)} status={data?.['1-0515']?.status}/>
                        <Cell unit={'516'} price={renderPrice(data?.['1-0516'], matrixType)} status={data?.['1-0516']?.status}/>
                        <Cell unit={'517'} price={renderPrice(data?.['1-0517'], matrixType)} status={data?.['1-0517']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'415'} price={renderPrice(data?.['1-0415'], matrixType)} status={data?.['1-0415']?.status}/>
                        <Cell unit={'416'} price={renderPrice(data?.['1-0416'], matrixType)} status={data?.['1-0416']?.status}/>
                        <Cell unit={'417'} price={renderPrice(data?.['1-0417'], matrixType)} status={data?.['1-0417']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'315'} price={renderPrice(data?.['1-0315'], matrixType)} status={data?.['1-0315']?.status}/>
                        <Cell unit={'316'} price={renderPrice(data?.['1-0316'], matrixType)} status={data?.['1-0316']?.status}/>
                        <Cell unit={'317'} price={renderPrice(data?.['1-0317'], matrixType)} status={data?.['1-0317']?.status}/>
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'215'} price={renderPrice(data?.['1-0215'], matrixType)} status={data?.['1-0215']?.status}/>
                        <Cell unit={'216'} price={renderPrice(data?.['1-0216'], matrixType)} status={data?.['1-0216']?.status}/>
                        <Cell unit={'217'} price={renderPrice(data?.['1-0217'], matrixType)} status={data?.['1-0217']?.status}/>
                    </Table.Row>
                </Table.Body>
            </Table>


        </div>
    );
};

export default Reflections;
